export { RelatedPlaces } from "./relatedPlaces";
